import {api} from "../core/api";
import {handleHttp, IProps} from "../core/handleHttp";
import {LoginServiceResponse} from "../interfaces/LoginResponse";

const preAlias = "/v1/auth";

export const login = async (body: any): Promise<LoginServiceResponse> => {
    let req: IProps = {
        api: api,
        type: "post",
        url: `${preAlias}`,
        body: body
    }
    return await handleHttp(req)
}